enum AccountType {
  BANK = 'BANK',
  SAVINGS = 'SAVINGS',
  CASH = 'CASH',
  INVESTMENT = 'INVESTMENT',
}

export default AccountType;
